import EmployeeList from "./EmployeeList";

export default EmployeeList;
